<template>
  <div id="home">

    <div class="content">
      <div class="flex"><el-input v-model="keywords" @change="searchFunction" placeholder="Practice Name,Email"></el-input></div>

      <el-table
        v-loading="table_loading"
        :data="tableData"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#F8F9FA',color:'#4A5468',fontWeight:'normal'}"
        :cell-style="{ fontSize: '14px'}"
        style="width: 100%;">
        <el-table-column
          align="center"
          prop="practiceName"
          min-width="100px"
          label="Practice Name">
        </el-table-column>
        <el-table-column
          align="center"
          prop="email"
          min-width="100px"
          label="Email">
        </el-table-column>
        <el-table-column
          align="center"
          prop="description"
          min-width="100px"
          label="Description">
        </el-table-column>
        <el-table-column
          align="center"
          min-width="100px"
          label="Date Time">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: center;">
              <p style="text-align: left;">
                {{moment(scope.row.createTime).format("MM-DD-yyyy")}}<br/>
                {{moment(scope.row.createTime).format("HH:mm:ss")}}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          min-width="80px"
          align="center">
          <template slot-scope="scope">
            <el-link type="primary" title="Show" @click="show(scope.row.id)"><i class="font-size-16 el-icon-search"></i></el-link>
            <el-link type="primary" title="Delete" style="margin-left: 10px;" @click="removeInfo(scope.row.id)"><i class="font-size-16 el-icon-delete"></i></el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div>
      <show ref="showForm"></show>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getAction,deleteAction } from '@/network/manage';
  import moment from 'moment/moment';
  import Show from './feedback/Show'
  export default {
    name: 'FeedbackList',
    components: {
      Show
    },
    data() {
      return {
        keywords:'',
        totalRows: 0,
        current_page: 1,
        page_size: 10,
        tableData: [],
        downloadShow: false,
        downloadUrl:'',
        deleteShow:false,
        deleteId:'',
        table_loading: false
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.getDatas(1)
    },
    methods:{
      moment,
      show(id) {
        this.$refs.showForm.init(id)
      },
      removeInfo(id){
        const that = this
        this.$confirm('Do you really want to delete this records?  This process cannot be undone.', 'confirm', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          that.table_loading = true
          deleteAction("/admin/feedback/delete?id="+id).then((res) => {
            if(res.success){
              that.$message({
                type: 'success',
                message: 'delete success!'
              });
              that.searchFunction()
            }else{
              that.$message.error(res.message);
            }
          }).catch((err) => {
            that.$message.error(res.message);
          }).finally((res) => {
            that.table_loading = false
          })
        })
      },
      searchFunction(){
        this.getDatas(1)
      },
      getDatas(initSize) {
        if(initSize == 1) {
          this.current_page = 1
        } else {
          this.current_page = initSize
        }
        this.table_loading = true
        getAction("/admin/feedback/list?pageSize=" + this.page_size + "&pageNo=" + this.current_page,{keywords:this.keywords}).then((res) => {
          if(res.success){
            this.tableData = res.result.records
            this.totalRows = res.result.total
          }else{
            this.$message.error(res.message);
          }
        }).catch((err) => {

        }).finally((res) => {
          this.table_loading = false
        })
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#E6ECEB;padding:20px;min-height: calc(100vh - 70px);}
  .content{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .flex{display: flex;justify-content: flex-end;width: 400px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 18px;color:#000000;}
  .font-size-16:hover{color:#3EA19D;text-decoration: none;}
  @media (max-width: 768px) {
    #home{padding:0;background-color:#ffffff;}
    .content{padding:20px 20px;border-radius: 0px;box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);}
    .flex{width: 100%;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
